import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { WordListActions, WordListStoreStates } from '.'
import { WLDefaultChip, WLDemoChip } from './styles'

type OwnProps = {}

type WordListProps = OwnProps & WordListStoreStates & WordListActions

const WordList = (props: WordListProps) => {
  const { readingWords } = props
  const { list, add } = readingWords
  const navigate = useNavigate()

  const onInput = (file: File | null | undefined) => {
    if (!file) return
    props.addList(file)
  }

  useEffect(() => {
    if (!readingWords.list.loading && !readingWords.list.loaded) props.loadList()
  }, [])

  if (list.loading || !list.loaded) return <></>

  return (
    <Container>
      <CssBaseline />
      <Paper sx={{ mb: 2 }}>
        <Toolbar>
          <Grid size="grow">
            <Typography variant="h6" style={{ flex: '1 1 100%' }}>
              発話リスト一覧
            </Typography>
          </Grid>
          {add.isSucceeded && (
            <Typography color="primary" variant="subtitle1">
              新規リストを追加しました
            </Typography>
          )}
          {add.isSucceeded === false && (
            <Typography color="secondary" variant="subtitle1">
              エラーが発生しました
            </Typography>
          )}
          <Tooltip title="CSVファイルから新規リストを作成します" disableInteractive>
            <Button variant="contained" component="label" color="primary" disabled={add.processing}>
              {add.processing ? <CircularProgress size={20} /> : 'リストを追加'}
              <input
                type="file"
                accept=".csv"
                style={{ display: 'none' }}
                onChange={(e) => onInput(e.target.files?.item(0))}
              />
            </Button>
          </Tooltip>
        </Toolbar>
        <TableContainer>
          <Table aria-label="word list">
            <TableHead>
              <TableRow>
                <TableCell>タイトル</TableCell>
                <TableCell align="right">最終更新日時</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.items.map((row) => (
                <TableRow
                  key={row.id}
                  hover
                  tabIndex={-1}
                  onClick={() => {
                    navigate(`/lip-reading/words/${row.id}`)
                  }}>
                  <TableCell component="th" scope="row">
                    {row.title}
                    {row.isDefault && <WLDefaultChip size="small" label="Default" />}
                    {row.canPredict && <WLDemoChip size="small" label="デモ" />}
                  </TableCell>
                  <TableCell align="right">{row.updatedDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  )
}

export default WordList
